import styled from 'styled-components';

export const ContainerInner = styled.div.attrs({ 'data-displayname': 'ContainerInner' })<{
    hasTopMargin?: boolean;
    isLoading?: boolean;
}>`
    margin: ${({ hasTopMargin = true }) => (hasTopMargin ? '40px 0 0 0' : '0')};
    padding: 0 32px 0 30px;
    display: flex;
    min-height: ${({ isLoading }) => (isLoading ? '100vh' : '')};
`;

export const ContainerInnerWithColumns = styled(ContainerInner)<{ isLoading?: boolean }>`
    flex-direction: column;
    min-height: ${({ isLoading }) => (isLoading ? '100vh' : '')};
`;
